import { render, staticRenderFns } from "./UsageBanner.vue?vue&type=template&id=3dca2edc&scoped=true&"
import script from "./UsageBanner.vue?vue&type=script&lang=js&"
export * from "./UsageBanner.vue?vue&type=script&lang=js&"
import style0 from "./UsageBanner.vue?vue&type=style&index=0&id=3dca2edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca2edc",
  null
  
)

export default component.exports